<template>
  <div class="page-content">
    <div class="page-title">
      <h5>论文答辩</h5>
    </div>
    <div class="panel">
      <div class="">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="批次">
            <el-select
              size="mini"
              v-model="defaultThesisBatchId"
              @change="getList"
            >
              <el-option
                v-for="item in configs"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          
        </el-form>
      </div>
    </div>
    <div class="">
      <div class="zs_table">
        <template v-if="!bm">
          <div style="margin-top: 5px; margin-bottom: 5px; color: red">
            <h4>未发现毕业论文报名记录，请与助学点联系</h4>
          </div>
        </template>
        <template
          v-if="
            bm &&
            (!db ||
              !thesis ||
              thesis.isOnlineReply === undefined ||
              thesis.isOnlineReply === null)
          "
        >
          <div style="margin-top: 5px; margin-bottom: 5px; color: red">
            <h4>您未进入论文答辩</h4>
          </div>
        </template>
        <el-table :data="tableData">
          <el-table-column prop="exam" label="批次" width="100" align="center">
            <template slot-scope>
              {{ config && config.name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="idCardNumber"
            label="身份证号"
            width="120"
            align="center"
          >
            <template slot-scope="">
              <span style="word-break: break-all" v-if="bm">
                {{ bm.idCardNumber }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zkxx"
            label="主考学校"
            align="center"
            width="170"
            show-overflow-tooltip
          >
            <template
              slot-scope="scope"
              v-if="scope.row && scope.row.schoolCode"
            >
              {{ scope.row.schoolCode + "-" + scope.row.schoolName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="zy"
            label="专业"
            align="center"
            width="140"
            show-overflow-tooltip
          >
            <template
              slot-scope="scope"
              v-if="scope.row && scope.row.specialtyCode"
            >
              {{ scope.row.specialtyCode + "-" + scope.row.specialtyName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="kc"
            label="课程"
            align="center"
            width="200"
            show-overflow-tooltip
          >
            <template
              slot-scope="scope"
              v-if="scope.row && scope.row.courseCode"
            >
              {{ scope.row.courseCode + "-" + scope.row.courseName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="t_name"
            label="标题"
            align="center"
            min-width="200"
            show-overflow-tooltip
          >
            <template slot-scope="" v-if="thesis">
              {{ thesis.name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="coach_name"
            label="答辩老师"
            width="80"
            align="center"
          >
            <template slot-scope="">
              <span v-if="db && db.sortNo">
                <span v-if="db.coachName1">{{ db.coachName1 }}</span>
                <span v-if="db.coachName2">、{{ db.coachName2 }}</span>
                <span v-if="db.coachName3">、{{ db.coachName3 }}</span>
              </span>
              <span v-else>
                <span v-if="thesis && thesis.coachName">{{
                  thesis.coachName
                }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sortNo"
            label="答辩序号"
            width="120"
            align="center"
          >
            <template slot-scope="" v-if="db">
              <span v-if="db.sortNo">
                {{
                  thesis && thesis.isOnlineReply && thesis.isOnlineReply == 1
                    ? "线上"
                    : "线下"
                }}
                第{{ db.sortNo }}组{{ db.groupNo }}号
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="答辩时间"
            width="140"
            align="center"
          >
            <template slot-scope="">
              <span v-if="db&&db.startTime"
                >{{ db.startTime | dateFormat("yyyy-MM-dd HH:mm") }} -
                {{ db.endTime | dateFormat("yyyy-MM-dd HH:mm") }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="exam_addr"
            label="答辩地点"
            width="100"
            align="center"
          >
            <template slot-scope="" v-if="db">
              <span v-if="db.examAddr">{{ db.examAddr }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="grate" label="成绩" width="150" align="center">
            <template slot-scope="" v-if="db">
              <!-- 答辩成绩-->
              <!-- 已到成绩公布时间,才会显示成绩 -->
              <template
                v-if="db  && (db.dbStatus == 2 || db.dbStatus == 3)"
              >
                <span style="color: #009900"
                  >答辩通过<br />成绩：
                  <template v-if="db.dbStatus == 2"> 待生效 </template>
                  <template v-if="db.dbStatus == 3">
                    {{ db.score }}分
                  </template>
                </span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="zt" label="状态" width="140" align="center">
            <template slot-scope="">
              <!-- 答辩状态 -->
              <template
                v-if="
                  bm &&
                  db &&
                  thesis
                "
              >
                <template v-if="db.dbStatus == 0"> 待上传（待答辩） </template>
                <template v-if="db.dbStatus == 1"> 已上传（已答辩） </template>
                <template v-if="db.dbStatus == 2"> 已打分 </template>
                <template v-if="db.dbStatus == 4"> 缺考 </template>
                <template v-if="db.dbStatus == 3">
                  <span style="color: green">已生效</span>
                  <template
                    v-if="db.isArchive !== null && db.isArchive !== undefined"
                  >
                    ,
                    <template v-if="db.isArchive == 1">
                      <span style="color: green">已归档</span>
                    </template>
                    <template v-if="db.isArchive == 0">
                      <span style="color: red">未归档</span>
                    </template>
                  </template>
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="archive_remark"
            label="备注"
            width="200"
            align="center"
          >
            <template slot-scope="">
              <span style="word-break: break-all" v-if="db">
                {{ db.archiveRemark }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="160"
            align="center"
            fixed="right"
          >
            <template slot-scope="">
              <div class="btns">
                <!-- 操作按钮-->
                <template v-if="db && db.thesisId">
                  <a href="javascript:void(0);" @click="load(db.thesisId)"
                    >详情</a
                  >
                </template>
                <template
                  v-if="
                    bm &&
                    db &&
                    thesis &&
                    thesis.isOnlineReply &&
                    thesis.isOnlineReply == 1
                  "
                >
                  <!-- 进入线上答辩 -->
                  <template v-if="db.status == 0|| db.status == 1">
                    <!-- <template v-if="config.isSchoolDb"> -->
                      <template
                        v-if="
                          config.isDeviceTest &&
                          curTime >= $utils.toTime(config.deviceTestStartTime) &&
                          curTime <= $utils.toTime(config.deviceTestEndTime)
                        "
                      >
                        <a
                          href="javascript:void(0);"
                          @click="equidebug(db.thesisId)"
                          >设备调试</a
                        >
                      </template>
                      <template
                        v-if="
                          curTime >= $utils.toTime(db.startTime) &&
                          curTime <= $utils.toTime(db.endTime)
                        "
                      >
                        <a href="javascript:void(0);" @click="zxdb(db.thesisId)"
                          >进入答辩等待区</a
                        >
                      </template>
                    <!-- </template>
                    <template v-else>
                      <template
                        v-if="
                          curTime >= $utils.toTime(config.examStartDate) &&
                          curTime <= $utils.toTime(config.examDate)
                        "
                      >
                        <a
                          href="javascript:void(0);"
                          @click="uploaderDb(db.thesisId)"
                          >上传答辩照片</a
                        >
                        |
                      </template>
                    </template> -->
                  </template>
                  
                </template>
                <template v-if="db && db.thesisId">
                  <a href="javascript:void(0);" @click="printTzd(bm.thesisBatchId)"
                    >打印考核单</a
                  >
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <PrintBmb ref="PrintBmb" />
    <Detail ref="Detail" />
    <DbForm ref="DbForm" />
    <faceRecognition
      ref="faceRecognition"
      type="zxdb"
      @submit="waitFn"
    ></faceRecognition>
    <!--<EquiDebug ref="EquiDebug" />
     <RoomSetting ref="RoomSetting" />
     <template v-if="equidebugVisible">
      <RoomContainer v-show="false" />
    </template> -->
  </div>
</template>

<script>
// import RoomSetting from "@/TUIRoom/components/RoomSetting/debug.vue";
// import RoomContainer from "@/TUIRoom/index.vue";
// import eventBus from "@/TUIRoom/hooks/useMitt";
// import LibGenerateTestUserSig from "@/utils/lib-generate-test-usersig.min.js";
import { mapState } from "vuex";

export default {
  name: "",
  components: {
    PrintBmb: () => import("./toPrintBmb.vue"),
    Detail: () => import("./thesisOnlineDetail.vue"),
    DbForm: () => import("./thesisOnlineDbForm.vue"),
    faceRecognition: () => import("@/components/faceRecognition.vue"),
    // EquiDebug: () => import("./equiDebug.vue"),
    // RoomSetting,
    // RoomContainer,
  },
  data() {
    return {
      formInline: {
        exam: "231",
      },
      dialogVisible: false,

      defaultThesisBatchId: "",
      config: {},
      configs: [],
      info: {},
      bm: {},
      curTime: "",
      db: {},
      thesis: {},
      thesisProposal: {},
      tableData: [],
      thesisId: null,
      roomData: {},
      equidebugVisible: false,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    this.getList();
    // eventBus.on("equidebug:close", () => {
    //   console.log(3);
    //   this.equidebugVisible = false;
    // });
  },
  methods: {
    getList() {
      this.$http
        .get("/student/thesis2/thesisOnlineDb", {
          thesisBatchId: this.defaultThesisBatchId,
        })
        .then((res) => {
          if (!this.defaultThesisBatchId)
            this.defaultThesisBatchId = res.defaultThesisBatchId;
          this.config = res.config;
          this.configs = res.configs;
          this.info = res;
          this.bm = res.bm;
          this.curTime = this.$utils.toTime(res.curTime);
          this.db = res.db;
          this.thesis = res.thesis;
          this.thesisProposal = res.thesisProposal;
          this.tableData = res.bm ? [res.bm] : [];

          // console.log(
          //   this.curTime >= this.config.examStartDate,
          //   this.curTime <= this.config.examDate
          // );
        });
    },
    details(e) {
      this.dialogVisible = true;
    },
    toRoute(path, query) {
      this.$router.push({
        path,
        query,
      });
    },
    load(id) {
      if (!id) {
        this.$message({
          showClose: true,
          message: "缺少参数. Parameters Required.",
          type: "error",
        });
        return;
      }
      this.$http
        .post("/student/thesis2/thesisOnlineDetail", { id },{isQs:1})
        .then((res) => {
          this.$refs.Detail.open(res);
        });
    },
    printTzd(thesisBatchId) {
      if (!thesisBatchId) {
        this.$message({
          showClose: true,
          message: "缺少参数. Parameters Required.",
          type: "error",
        });
        return;
      }
      this.$refs.PrintBmb.open(thesisBatchId);
    },
    uploaderDb(thesisId) {
      this.$refs.DbForm.open(thesisId);
    },
    zxdb(thesisId) {
      const _t = this;
      _t.$http
        .post("/student/thesis2/user/isWaitingArea", {
          thesisId,
        },{isQs:1})
        .then((res) => {
          if (this.config.comparison == 1) {
            this.$refs.faceRecognition.open({
              thesisId,
              thesisBatchId:_t.thesis.thesisBatchId
            });
          } else {
            this.waitFn();
          }
        });

      return;
      this.$http
        .post("/thesis/db/online/user/enterOnlineReply", {
          thesisId,
        })
        .then((res) => {
          this.roomData = res;
          if (this.config.comparison == 1) {
            this.$refs.faceRecognition.open({
              thesisId,
            });
          } else {
            this.waitFn();
          }
        });
    },
    toWaitingArea() {
      this.$router.push({
        path: "/db-waiting-area",
        query: {
          thesisId: this.db.thesisId,
          groupId: this.db.groupId,
          courseCode: this.bm.courseCode,
          courseName: this.bm.courseName,
        },
      });
    },
    equidebug(id) {
      const { protocol, host } = window.location;
      // 拼接 query 参数
      let query = `id=${id}`;

      const newUrl = `${protocol}//${host}/debug/#index?${query}`;
      window.open(newUrl, '_blank');
      return
      this.equidebugVisible = true;
      const _t = this;
      this.$nextTick(() => {
        eventBus.emit("equidebug:open", (closeDialog) => {
          _t.$http
            .post("/thesis/db/online/user/deviceTestOver", {
              thesisId: _t.db.thesisId,
            })
            .then((res) => {
              if (res) {
                closeDialog();
                _t.toMockDefense();
              }
            });
        });
      });
    },
    toMockDefense() {
      const _t = this;
      const userId = _t.user.userId;
      const username = _t.user.username;
      const userPhotoUrl = _t.user.phone;
      const sdkAppId = +process.env.VUE_APP_SDKAPPID,
        sdkSecretKey = process.env.VUE_APP_SDKSECRETKEY,
        dbRoomId =
          "T-" + userId + "-" + _t.$utils.dateFormat(new Date(), "HHmmss");
      const userSigGenerator = new LibGenerateTestUserSig(
        sdkAppId,
        sdkSecretKey,
        604800
      );
      const userSig = userSigGenerator.genTestUserSig(userId);
      const roomData = {
        sdkAppId,
        userId,
        userSig,
        username,
        userPhotoUrl,
        dbRoomId,
        roomName: "模拟答辩",
      };
      _t.$store.commit("SET_ROOMDATA", roomData);
      const { href } = this.$router.resolve({
        path: "/online-defense-room-debug",
        query: { roomId: roomData.dbRoomId },
      });
      window.open(href, "_blank");
    },
    waitFn(photoPath) {
      this.toWaitingArea();
      return;
      this.$store.commit("SET_ROOMDATA", this.roomData);
      const { href } = this.$router.resolve({
        path: "/online-defense-room",
        query: { roomId: this.roomData.dbRoomId },
      });
      window.open(href, "_blank");
    },
  },
  destroyed() {
    // eventBus.off("equidebug:close");
    // eventBus.off("equidebug:open");
  },
};
</script>
<style scoped lang="scss">
.el-form-item {
  margin-bottom: 0px;
}

.btns {
  a+a {
    margin-left: 8px;
  }
}

</style>
